
// export const baseRoute = '/html/nycx/financialchallenge';

export const baseRoute = '';

export const language = {

    eng: {

        nav: [

            {

                url: '/challenge',

                title: 'Challenge'

            },

            {

                url: '/context',

                title: 'Context'

            },

            {

                url: '/process',

                title: 'Process'

            },

            {

                url: '/criteria',

                title: 'Criteria'

            },

            {

                url: '/team',

                title: 'Team'

            },

            {

                url: '/faq',

                title: 'FAQ'

            },

        ],

        ctaButtonText: 'VIEW THE RESULTS',

        applyLink: 'https://www1.nyc.gov/assets/cto/#/project/financial-inclusion-challenge',

        // alertBottom: "Please read the ",

        // alertBottomLink: "https://www1.nyc.gov/html/nycx/5gdesignchallenge/#/terms-and-conditions",

        // alertBottomLinkText: "Additional Terms and Conditions",

        challenge: {

            heroImage: './assets/FI_hero.jpg',

            heroAlt: 'NYC streetscape photo',

            titleSuper: 'NYC[<small class="bold">x</small>] Moonshot',

            title: 'Financial Inclusion Challenge',

            alert: "The winners and honorees have been selected!",

            alertLink: "https://www1.nyc.gov/assets/cto/#/project/financial-inclusion-challenge",
    
            alertLinkText: "Click here to view the results.",

            big: 'We are here to address huge New York City challenges with bold, innovative solutions.',

            explainerText: 'The NYC[x] Moonshot: Financial Inclusion Challenge is part of the inclusive innovation efforts of the City of New York to connect the NYC tech ecosystem, local communities, innovators across the world, youth, and government agencies to address the multifaceted barriers unbanked and underbanked New Yorkers face and support equitable recovery.',

            challengeTextTitle: 'Challenge Statement',

            challengeText: 'How might we utilize breakthrough financial inclusion technology, innovative models, and culturally relevant approaches to build community wealth and sustainable economic opportunities for unbanked and underbanked communities in the Bronx and across New York City?',

            cta: 'The winners and honorees have been selected',

            ctaButtonText: 'VIEW THE RESULTS',
            perks: [

                {

                    iconSrc: './assets/icons/home/pilot_icon_FI.svg',

                    iconAlt: 'decorative squares',

                    title:'Showcase Your Solutions and Ideas to Potential Partners'

                },

                {

                    iconSrc: './assets/icons/home/money_icon_FI.svg',

                    iconAlt: 'abstract representation of money',

                    title: 'Win up to $20k in Prize Money'

                },

                {

                    iconSrc: './assets/icons/home/scale_icon_FI.svg',

                    iconAlt: 'abstract representation of scaling',

                    title: 'Interactions May Uncover Acceleration and Scaling or Technical Prototype Development Support Opportunities'

                },

                {

                    iconSrc: './assets/icons/home/network_icon_FI.svg',

                    iconAlt: 'representation of a network using interconnected circles',

                    title: 'Grow Your Industry Network'

                },

            ],


        },

        context: {

            whyImportant: 'Why is this important?',

            stats: [
                {
                    stat: '1 million',
                    text: 'Households across New York City have no bank account (unbanked) or have a bank account but use alternative financial products for some banking needs (underbanked)',
                },
                {
                    stat: '49.2%',
                    text: 'Households in the Bronx are unbanked or underbanked (compared to 26.5% nationally and 33% across New York City)', 
                },
                {
                    stat: '$1.2 billion',
                    text: 'In overdraft, ATM, and maintenance fees were extracted from New Yorkers across the city by banks during the pandemic', 
                },
            ],

            whyNeighborhood: 'Why these priority neighborhoods?',

            communityContext:`Out of the ten most unbanked New York City neighborhoods, six are in the Bronx:
            <br/><br/>
            <ol>
                <li>Bedford Park, Fordham North, and Norwood;</li>
                <li>Morris Heights, Fordham South, and Mount Hope;</li>
                <li>Belmont, Crotona Park East, and East Tremont;</li>
                <li>Castle Hill, Clason Point, and Parkchester;</li>
                <li>Concourse, Highbridge, and Mount Eden;</li>
                <li>Hunts Point, Longwood, and Melrose.</li>
            </ol>
            Challenge Participants should design solutions that could support New Yorkers in the six Bronx neighborhoods above 
            (Priority Neighborhoods) with the potential to scale citywide.<br/><br/>The ten most unbanked New York City neighborhoods 
            account for nearly 35 percent of all unbanked households across the city. Residents of those ten neighborhoods, including 
            all six Priority Neighborhoods, are predominantly Black or Latino/a, have higher rates of unemployment, are living in poverty 
            at higher rates, and have a lower median household income compared to the city as a whole.  They are more likely to have 
            no credit score or a subprime credit score and hold delinquent debt. Residents of these neighborhoods are also less likely to have access to the internet.
            <br/><br/>New York City’s unbanked and underbanked households are highly concentrated in neighborhoods that have higher rates of vulnerable residents and residents also 
            struggling in other areas of financial health.<br/><br/>Eight of ten neighborhoods in the Bronx, including all six 
            Priority Neighborhoods, are “Neighborhood Financial Health Vulnerable” across the NYC Department of Consumer and Worker 
            Protection’s five goals of Neighborhood Financial Health. Specifically for Goal 1, which focuses on the presence of 
            financial services that would result in residents having “Access to Affordable, High-Quality Financial Services”, 
            seven out of ten neighborhoods in the Bronx, including five Priority Neighborhoods, fall in the bottom tier of this goal 
            demonstrating that these neighborhoods have low ratios of bank/credit-union to check cashers and pawn shops, bank/credit-union
             density and low to zero percentage of IDNYC acceptance as a primary form of identification to open an account.  
             Other indicators for this goal include bank/credit union utilization, presence of affordable products and mobile 
             banking utilization.`,
            
            call: `“Financial inclusion [is] a key enabler to reduce extreme poverty and boost shared prosperity.” - The World Bank`,
            ask1: `<strong>And yet… <br/><br/>“The financial system is not designed to serve low-income consumers, and is rife with systemic racism that harms Black Indigenous People of Color (BIPOC) communities.” - San Francisco Office of Financial Empowerment</strong><br><br>The City of New York is seeking to solicit creative, tech-enabled solutions that advance any combination of the following outcomes for communities, their residents, and their businesses: 
            <br/><br/>
            <ul>
            <li><b>Innovative Models</b> - Novel business, governance, or other models that build community wealth and assets rather than extract them </li>
            <li><b>Ownership</b> - Increase and preserve ownership by communities and individuals; reduce the barriers and increase opportunities to build assets and own businesses</li>
            <li><b>Incomes</b> - Increase incomes of community members; enable routinely positive cash flows</li> 
            <li><b>Bankedness</b> - Increase the number of New Yorkers that have consumer-friendly, affordable bank accounts that meet their needs</li>
            <li><b>Trust</b> - Increase trust and reliance in financial institutions, products, and services</li>
            <li><b>Bank Deserts</b> - Addresses the lack of brick and mortar financial institutions</li>
            <li><b>Accessibility</b> - Increase accessibility of consumer-friendly, affordable banking or wealth building products (credit and/or asset building) and services</li>
            <li><b>User-Centeredness and Cultural Competence</b> - Solutions are developed with the end-user experience and cultural context in mind</li>
            <li><b>Products & Services</b> - Provide non-predatory (without aggressive or deceptive tactics) financial products and services </li>
            <li><b>Education</b> - Increase knowledge about the benefits of maintaining a safe and affordable bank account; which institutions, products, and services are trusted and accessible; the process for opening a bank account; and other wealth building opportunities</li>
            <li><b>Small Business Support</b> - Increase access to financing, banking accounts, and user-centered support</li>
            <li><b>Leveraged Community Assets</b> - Leverage community assets and collective economic power to support communities and individuals</li>
            </ul>
            `,

            ask2: '',

            mapSrc: "./assets/FI_map.png",

            mapAlt: "A map showing Unbanked and Underbanked Households and the Ratio of Banks and Credit Unions per Alternative Financial Institution. Areas like The Bronx and central Brooklyn have the highest share of underbanked and unbanked residents, and also the highest rates of AFIs compared to formal banks.",

            downloadTitle: 'Download the Challenge Manual',

            downloadButtonText: 'DOWNLOAD',

            challengeManualUrl: 'http://www.nyc.gov/html/nycx/documents/cto_financialchallenge_manual.pdf'

        },

        process: {

            pageTitle: 'Process',

            pageTitleText: 'The NYC[x] Moonshot: Financial Inclusion Challenge is a unique opportunity to design solutions that address the systemic and structural inequalities contributing to the financial fragility of many communities of color across New York City. Challenge winners will be selected in November/December 2021.',

            // participantsTitle: 'Benefits for Participants',

            // participantsImg: './assets/process_blocks_illustration_FI.svg',

            // participantsImgAlt: 'decorative illustration with circles and blocks of different colors',

            // participantsText: `Challenge winners and finalists will be featured on the NYC[x] Moonshots Challenge website.
            // <br/><br/>
            // All applications will be shared with an evaluation panel with representatives from NYC government agencies, community-based organizations, and industry experts.
            // <br/><br/>
            // Finalist applications will also be shared with a venture capitalist partner for evaluation. 
            // <br/><br/>
            // Finalists will get targeted feedback from the evaluation panel including NYC government agencies, community and industry experts, and a venture capitalist. 
            // `,

            winnersTitle: 'Why You Should Apply',

            // winnersIntro: '',

            winnersBenefits: [

                {

                    iconSrc: './assets/icons/home/pilot_icon_FI.svg',

                    iconAlt: 'decorative squares',

                    title:'Showcase Your Solutions and Ideas to Potential Partners',

                    text:`Evaluation panel members include NYC government agencies, community-based organizations, 
                    industry experts, and venture capitalists
                    `

                },

                {

                    iconSrc: './assets/icons/home/money_icon_FI.svg',

                    iconAlt: 'abstract representation of money',

                    title: 'Win up to $20k in Prize Money',

                    text: `Implementation-Ready Solutions: Win up to $20,000 USD
                    <br/><br/>
                    Idea-Stage Solutions: Win up to $5,000 USD
                    `

                },

                {

                    iconSrc: './assets/icons/home/scale_icon_FI.svg',

                    iconAlt: 'abstract representation of scaling',

                    title: 'Interactions May Uncover Acceleration and Scaling or Technical Prototype Development Support Opportunities',

                    // text: `
                    // `

                },

                {

                    iconSrc: './assets/icons/home/network_icon_FI.svg',

                    iconAlt: 'representation of a network using interconnected circles',

                    title: 'Grow Your Industry Network',

                    text: `Access networking events
                    <br/><br/>
                    Gain publicity through the City of New York, NYC[x] Moonshots network of international cities, and industry marketing channels
                    `

                },

            ],

            processTitle: 'Challenge Process',

            processText: `The challenge is open to everyone regardless of background, experience, or geographic location - all relevant and compelling ideas will be taken into consideration. There is no minimum business or growth stage required.  The City invites stakeholders from a diversity of backgrounds to respond including fintech companies, community groups, and youth. Partnerships between different stakeholders are strongly encouraged. Applicants may submit their solution to one of the tracks below based on solution maturity:
            <br/><br/><ul>
            <li><b>Track 1: Implementation-Ready Solutions</b> - Mature solutions that could be implemented with real New Yorkers in the Bronx at the time of final submission and have the potential to scale citywide </li>
            <li><b>Track 2: Idea-Stage Solutions</b> - Solution ideas that are not yet mature enough for implementation and can benefit from solution development support</li>
            </ul>
            All events will be online. Dates are subject to change. Sign up for updates through the <a href="https://forms.office.com/g/b38Sek6p94">Contact Form</a>. `,

            phases: [

                {

                    date: 'July 2021',

                    triggerDate: 1627790399000,

                    title: 'Challenge Begins',

                    text: 'Open Call applications accepted on a rolling basis through September 26.'

                },

                {
                    
                    date: 'August 25, 2021',

                    triggerDate: 1629950399,

                    title: 'Information Session',

                    text: 'Join us online at 1pm EDT. Learn about the challenge and ask Organizers questions. Submitting questions ahead of time is recommended. Sign up and submit questions through our <a class="text-accent" href="https://forms.office.com/g/b38Sek6p94">Contact Form</a>.'
                },

                {
                    date: 'September 26, 2021',
 
                    triggerDate: 1632196799,
  
                    title: 'Open Call Application Deadline',
  
                    text: 'Open Call applications due by September 26, 2021 11:59 PM EDT.'
                },

                {
                    date: 'October 2021',

                    triggerDate: 1635739199,

                    title: 'Finalists Notified',

                    text: 'Finalists notified and provided with the Finalist application that will ask them to describe how their solution addresses the Round 2 Evaluation Criteria.'
                },


                {
 
                    date: 'November 1, 2021',
  
                    triggerDate: 1635825599,
  
                    title: 'Finalist Application Deadline',
  
                    text: 'Finalist applications due November 1, 2021 11:59 PM EDT.'
  
                },

                {

                    date: 'November 2021',

                    triggerDate: 1638334799,

                    title: 'Pitch + Q/A Event',

                    text: 'Finalists invited to an event where they will pitch their solutions and participate in a Q/A session with the evaluation panel. This session will be conducted via video conference. Sign up to get updates about this event through our <a class="text-accent" href=https://forms.office.com/g/b38Sek6p94’>Contact Form</a>.'

                },

                {

                    date: 'November / December 2021',

                    triggerDate: 1641013199,

                    title: 'Winners Announced',

                   // text: 'Winners announced November/December 2021'

                },

            ],

            // pilotTitle: 'Pilot',

            // pilotText: 'Track 1: Pilot-Ready Solutions - The winning team(s) with pilot-ready solutions will pilot their solution in the Bronx starting in Fall 2021 and ending in early 2022 in collaboration with the the Mayor’s Office of the Chief Technology Officer (MOCTO), Office of Financial Empowerment (OFE), and a pilot implementation consultant.<br/><br/>Throughout the duration of the pilot, MOCTO, OFE, and the pilot implementation consultant will evaluate the solution’s efficacy meeting the challenge’s goals and determine next steps, which may include releasing an open solicitation to deploy the solution on a larger scale.',

            // fundingTitle: 'Funding',

            // fundingText: 'Track 1: Pilot-Ready Solutions - We anticipate funding up to three pilots. Each winner with a pilot-ready solution will receive up to $20,000 in funding to support pilot implementation. Funds should be used to implement and ensure the success of the pilot. This includes, but is not limited to, equipment purchase and installation, as well as for expenses related to insurance, maintenance, user testing, and evaluation.<br/><br/> Track 2: Idea Stage Solutions - We anticipate funding up to three idea stage winners who will complete a report describing how the solution meets the evaluation criteria and what’s needed to develop the solution. Each Track 2 challenge winner will receive up to $5,000 in funding to develop the report.',

            downloadTitle: 'Download the Challenge Manual',

            downloadButtonText: 'DOWNLOAD',

            challengeManualUrl: 'http://www.nyc.gov/html/nycx/documents/cto_financialchallenge_manual.pdf'

        },

        criteria: {

            pageTitle: 'Criteria',

            criteriaItems: [

                {

                    iconSrc: './assets/icons/criteria/innovative_icon_FI.svg',

                    iconAlt: 'representation of innovative using green circles surrounding a yellow circle',

                    title: 'Innovative',

                    text: 'Solution is original and demonstrates an innovative approach. It includes novel business models, technologies, concepts, processes, tools or governance models as a test-bed for innovation.'

                },

                {

                    iconSrc: './assets/icons/criteria/empowering_icon_FI.svg',

                    iconAlt: 'representation of empowering using two hearts',

                    title: 'Empowering',

                    text: 'Successful solutions should create and support opportunity, equity, self-determination, and self-efficacy.'

                },

                {

                    iconSrc: './assets/icons/criteria/usercentered_icon_FI.svg',

                    iconAlt: 'representation of user-centered using a green figure in front of two yellow figures',

                    title: 'User-Centered',

                    text: 'Solutions should be developed with the end-user experience in mind. They should be linguistically inclusive (literacy level and offered in at least Spanish and English) and culturally competent. We encourage solutions that can be adapted to different linguistic needs.'

                },

                {

                    iconSrc: './assets/icons/criteria/accessible_icon_FI.svg',

                    iconAlt: 'abstract representation of accessible using squares ',

                    title: 'Accessible',

                    text: 'Successful solutions should serve, be inclusive of, and be usable by all members of the community.'
                },

                {

                    iconSrc: './assets/icons/criteria/nonextractive_icon_FI.svg',

                    iconAlt: 'abstract representation of non-extracting using rectangles',

                    title: 'Non-Extractive',

                    text: 'The solution builds, preserves, or protects wealth and assets within communities rather than extracting them.'

                },

                {

                    iconSrc: './assets/icons/criteria/safe_icon_FI.svg',

                    iconAlt: 'representation of safe using a rainbow',

                    title: 'Safe',

                    text: 'The solution is non-predatory (without aggressive or deceptive tactics).  It creates a safe environment for communities to be part of/utilize the solution.'

                },


                {

                    iconSrc: './assets/icons/criteria/affordable_icon_FI.svg',

                    iconAlt: 'abstract representation of affordable using rectangles',

                    title: 'Affordable',

                    text: 'Fair prices should not be a barrier for any target audience member who wants to utilize the solution.'

                },

                {

                    iconSrc: './assets/icons/criteria/trusted_icon_FI.svg',

                    iconAlt: 'representation of trusted using two circles touching',

                    title: 'Trusted',

                    text: 'Solution should build trust and reliance in their relationship with the community and make their fees/fines, products, policies and practices, outcomes, partners, and participants clear and transparent.'
                },

                {

                    iconSrc: './assets/icons/criteria/secure_icon_FI.svg',

                    iconAlt: 'representation of secure using two nested squares',

                    title: 'Secure',

                    text: 'The solution should have practices of protecting the financial assets and digital information of New Yorkers.'
                },

                {

                    iconSrc: './assets/icons/criteria/scalable_icon_FI.svg',

                    iconAlt: 'abstract representation of scalable using squares',

                    title: 'Scalable',

                    text: 'Solution could scale to benefit hundreds, thousands (perhaps even millions) of people in the future.'
                },

                {

                    iconSrc: './assets/icons/criteria/relevant_icon_FI.svg',

                    iconAlt: 'abstract representation of relevant using circles',

                    title: 'Relevant',

                    text: 'The solution defines a need(s) or unresolved problem(s) being addressed in its context.'
                },

                {

                    iconSrc: './assets/icons/criteria/impactful_icon_FI.svg',

                    iconAlt: 'representation of impactful using a staircase',

                    title: 'Impactful',

                    text: '(Track 1 Finalists) Solutions propose clear, significant, and measurable outcomes. Solutions should demonstrate a clear contribution to future action plans and decision making processes.'
                },

                {

                    iconSrc: './assets/icons/criteria/implementable_icon_FI.svg',

                    iconAlt: 'representation of implementable a wrench ',

                    title: 'Implementable',

                    text: '(Track 1 Finalists) Solution can be implemented within current regulations and can be properly tested to receive feedback from potential users and stakeholders. Cost-effective solutions that can be quickly implemented are especially attractive. Applicants demonstrate relevant experience or knowledge that would support successful implementation.'
                },

                {

                    iconSrc: './assets/icons/criteria/sustainable_icon_FI.svg',

                    iconAlt: 'abstract representation of sustainable using rectangles',

                    title: 'Sustainable',

                    text: '(Track 1 Finalists) Considerations for the solution’s maintenance, continuous usage, and ability to be improved. It has long-term financial stability taken into account.'
                },

                {

                    iconSrc: './assets/icons/criteria/compliant_icon_FI.svg',

                    iconAlt: 'representation of compliant using a checkbox ',

                    title: 'Compliant',

                    text: '(Track 1 Finalists) Successful solutions should follow <a href="https://iot.cityofnewyork.us">NYC IoT Guidelines</a> (on privacy, transparency, infrastructure, data management, security, operations, and sustainability), and all applicable NYC rules and regulations.'
                },

                {

                    iconSrc: './assets/icons/criteria/promising_icon_FI.svg',

                    iconAlt: 'abstract representation of promising using rectangles',

                    title: 'Promising',

                    text: '(Track 2 Finalists) A solution’s potential future success will be considered based on the goals, risks, and needs identified.'
                },
                

            ]

        },

        team: {

            pageTitle: 'Team',

            judgeTitle: 'City Agency Organizers',

            judges: [

                {

                    photoSrc: './assets/logos/MOCTO_logo.png',

                    photoAlt: 'logo of the NYC Mayor’s Office of the Chief Technology Officer',

                    description: 'The NYC Mayor’s Office of the Chief Technology Officer (MOCTO)\'s mission is to ensure that technology is inclusive, accessible, human-centered, and works for all New Yorkers. MOCTO views technology as a critical tool for realizing the Mayor’s vision of making New York City the fairest big city in America.'

                },

                {

                    photoSrc: './assets/logos/DCWP_logo.png',

                    photoAlt: 'logo of the NYC Department of Consumer and Worker Protection Office of Financial Empowerment',

                    description: 'Within the Department of Consumer and Worker Protection (DCWP), the Office of Financial Empowerment (OFE) focuses on initiatives that support New Yorkers and communities with low incomes in building wealth and improving their financial health. OFE is the first local government initiative in the country with the mission to educate, empower, and protect New Yorkers and neighborhoods with low incomes so they can build assets and make the most of their financial resources. OFE uses data and research, policy, partnerships, and convenings to advance its mission. Using this model, OFE is able to  develop, offer, and advocate for innovative programs and products for all New Yorkers.'

                },

                {

                    photoSrc: './assets/logos/SBS_logo.png',

                    photoAlt: 'logo of the NYC Department of Small Business Services',

                    description: 'NYC Department of Small Business Services (SBS) helps unlock economic potential and create economic security for all New Yorkers by connecting New Yorkers to good jobs, creating stronger businesses, and building thriving neighborhoods across the five boroughs.'

                },

                {

                    photoSrc: './assets/logos/YMI_logo.png',

                    photoAlt: 'logo of the NYC Young Men\'s Initiative',

                    description: 'NYC Young Men’s Initiative (YMI) was created as a public-private partnership to address increasing disparities among black and Latino men between the ages of 16 and 24 in education, employment, health and justice. The YMI mission is to develop and champion policies, programs and partnerships that holistically support the success of young men of color throughout NYC.'
                },

            ],

            // partnerTitle: 'Industry Partners - Coming Soon',

            partners: [],

            //     {

            //         photoSrc: '',

            //         photoAlt: '',

            //         description: 'Coming Soon!'

            //     },

            //     {

            //         photoSrc: '',

            //         photoAlt: '',

            //         description: '.'

            //     },

            //     {

            //         photoSrc: '',

            //         photoAlt: '',

            //         description: '.'

            //     }

            // ],

            cityPartnerTitle: 'Community & Industry Evaluators',

            cityPartners: [

                {
 
                    photoSrc: './assets/logos/1199seiu_logo.png',
  
                    photoAlt: 'logo of 1199SEIU',
  
                },

                {

                    photoSrc: './assets/logos/Ariva_logo.png',

                    photoAlt: 'logo of Ariva',

                },

                {

                    photoSrc: './assets/logos/BronxImpact_logo.png',

                    photoAlt: 'logo of Bronx Impact',

                },

                {

                    photoSrc: './assets/logos/bronxworks_logo.png',

                    photoAlt: 'logo of BronxWorks',

                },

                {

                    photoSrc: './assets/logos/financialhealthnetwork_logo.png',

                    photoAlt: 'logo of Financial Health Network',

                },

                {

                    photoSrc: './assets/logos/fordhamfoundry_logo.png',

                    photoAlt: 'logo of Fordham Foundry',

                },

                {

                    photoSrc: './assets/logos/levelup_logo.png',

                    photoAlt: 'logo of Level Up Ventures',

                },

                {

                    photoSrc: './assets/logos/EDC_logo.png',

                    photoAlt: 'logo of New York City Economic Development Corporation',

                },

                {

                    photoSrc: './assets/logos/P20_logo.png',

                    photoAlt: 'logo of P20',

                },

                {

                    photoSrc: './assets/logos/sprucesystems_logo.png',

                    photoAlt: 'logo of Spruce Systems',

                },

                {

                    photoSrc: './assets/logos/whedco_logo.png',

                    photoAlt: 'logo of WHEDco',

                },

                {

                    photoSrc: './assets/logos/zeal_logo.png',

                    photoAlt: 'logo of Zeal Capital Partners',

                },

            ],
            supportersTitle: 'Supporters',
            supporters: [
                // {
                //     name: 'FinTech Innovation Lab',
                //     description: 'Co-founded by the Partnership Fund for New York City & Accenture'
                // },
                {
                    name: 'LendIt Fintech',
                    description: ''
                },
                // {
                //     name: 'Mastercard Start Path',
                //     description: ''
                // },
                // {
                //     name: 'NYC Department of Finance',
                //     description: ''
                // },
                // {
                //     name: 'NYC Department of Housing Preservation & Development',
                //     description: ''
                // },
                // {
                //     name: 'Rise New York',
                //     description: 'Created by Barclays'
                // },
            ]

        },

        faq: {

            pageTitle: 'FAQ',

            faqItems: [

                {
//                     question: 'Please submit questions <a href="https://forms.office.com/g/b38Sek6p94">here</a>.',
                    answer: 'Questions and answers of general applicability may be posted on this challenge website. Other questions may be answered privately.',
                },

                // {
                //     question: '',
                //     answer: '',
                // },
                
                // {
                //     question: '',
                //     answer: '',
                // },

                // {
                //     question: '',
                //     answer: '',
                // },

                // {
                //     question: '',
                //     answer: '',
                // },

                // {
                //     question: '',
                //     answer: '',
                // },

                // { 
                //     question: '', 
                //     answer: '', 
                // }, 
                
                // {
                //     question: '',
                //     answer: '',
                // },

                // {
                //     question: '',
                //     answer: '',
                // },

                // {
                //     question: '',
                //     answer: '',
                // },

                // {

                //     question: '',

                //     answer: '',

                // },

            ]

        },
        // termsAndConditions: {

        //     pageTitle: '',

            // sections: [
            //     {
            //         // header: '',
            //         body: '',
            //     },

            //     {

            //         header: '',

            //         body: '',

            //     },

            //     {

            //         header: '',

            //         body: '',
            //     },

                // {

                //     header: '',

                //     body: '',

                // },

                // {

                //     header: '',

                //     body: '',

                // },

                // {

                //     header: '',

                //     body: '',

                // },

                // {

                //     header: '',

                //     body: '',

                // },


                // {

                //     header: '',

                //     body: '',

                // },


                // {

                //     header: '',

                //     body: '',

                // },

                // {

                //     header: '',

                //     body: '',

                // },

                // {

                //     header: '',

                //     body: '',

                // },

                // {

                //     header: '',

                //     body: '',

                // },

                // {

                //     header: '',

                //     body: '',

                // },

                // {

                //     header: '',

                //     body: '',

                // },

                // {

                //     header: '',

                //     body: '',

                // },

                // {

                //     header: '',

                //     body: '',

                // },
                

        //     ]
        // }

    }

}
